import { authFetch } from './session';
import { BACKEND_URL, API } from './api';

export const updateCartBadge = async () => {
  try {
    const r = await authFetch(`${API}/user/cart`, {  });
    if (r.ok) {
      const items = await r.json();
      window.dispatchEvent(new CustomEvent('cart-updated', { detail: items?.length || 0 }));
    }
  } catch (e) { console.error('Cart badge update failed:', e); }
};
